import React from 'react'

import { PageName } from 'generated/types'

import { ExternalNavbarProps, NavigationBar } from '../NavigationBar'
import { ButtonContainer, FooterTextContainer, Separator } from '../shared-styled-components'
import {
  ContentContainer,
  FooterContainer,
  Headline,
  ImageContainer,
  Page,
  Subtitle,
} from './styled-components'
import { FunnelContent } from '../FunnelContent'

interface Props {
  headlineText: string
  subtitleText?: string | React.ReactNode
  image: React.ReactNode
  pageName: PageName
  footer?: React.ReactNode
  button?: React.ReactNode
  children?: React.ReactNode
  navigationBar?: ExternalNavbarProps
  className?: string
  eventObjectName: string // this is the object name of the page that the user is currently on
}

export const InterstitialLayout = (props: Props) => (
  <div className={props.className}>
    <FunnelContent pageName={props.pageName} eventObjectName={props.eventObjectName} />
    <NavigationBar
      {...props.navigationBar}
      pageName={props.pageName}
      eventObjectName={props.eventObjectName}
    />
    <Page
      content={
        <>
          <ContentContainer>
            <ImageContainer>{props.image}</ImageContainer>
            <Headline hasExtraSpacing={!props.subtitleText}>{props.headlineText}</Headline>
            {props.subtitleText && <Subtitle>{props.subtitleText}</Subtitle>}
            {props.children}
          </ContentContainer>
          {(props.footer || props.button) && (
            <>
              <Separator />
              <FooterContainer>
                {props.footer && <FooterTextContainer>{props.footer}</FooterTextContainer>}
                {props.button && <ButtonContainer>{props.button}</ButtonContainer>}
              </FooterContainer>
            </>
          )}
        </>
      }
    />
  </div>
)
